import React, { useState } from 'react';
import PropTypes from 'prop-types';

// components
import Logotype from './images/cloudnine-logotype';
import MainMenu from '../MainMenu/MainMenu';
import SlideIn from '../../components/SlideIn/SlideIn';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import LocalizedLink from '../LocalizedLink/LocalizedLink';

// styles
import './site-header.scss';

const SiteHeader = ({halfPage, languageSelectorInformation, pathname, color, logoColor}) => {
  const [open, setOpen] = useState(false);
  
  const handleClick = (e) => {
    if (e === 27) {
      setOpen(false);
      return;
    }

    setOpen(prevState => !prevState);
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      setOpen(prevState => !prevState);
    }
  }

  return (
    <div className="site-header">
      <div className="site-header__wrapper">
        <div className={`site-header__logo ${open ? 'open' : ''} ${halfPage ? 'half-page' : ''}`}>
          <LocalizedLink to="/">
            <Logotype
              color={logoColor ? logoColor : color}
              halfPage={halfPage}
            />
          </LocalizedLink>
        </div>
        <div className="site-header__navigation-wrapper">
          <LanguageSelector languageSelectorInformation={languageSelectorInformation} path={pathname} inverted={color !== 'white'} halfPage={halfPage} />
          <div
              id="site-header-menu"
              className={`site-header__menu ${
                  pathname.indexOf('slug') !== -1 ||
                  pathname.indexOf('news') !== -1
                      ? 'inverted'
                      : ''
              }`}
          >
            <div
                className={`site-header__menu-button-container ${
                    open ? 'open' : ''
                }`}
              onClick={handleClick}
              onKeyDown={handleKeyDown}
              role='button'
              tabIndex={0}
            >
              <div
                  className={`site-header__menu-button-wrapper`}
              >
              <span
                  className={`site-header__menu-button ${
                      open ? 'open' : ''
                  } ${color === 'white' ? 'light' : 'dark'}
                  ${halfPage ? 'half-page' : ''}`}
              />
              </div>
            </div>
          </div>
        </div>
        <SlideIn className="main-menu-slide-in" in={open} close={handleClick} isMenu>
          <MainMenu />
        </SlideIn>
      </div>
    </div>
  );
}

export default SiteHeader;

SiteHeader.defaultProps = {
  cases: [],
  pathname: ''
};

SiteHeader.propTypes = {
  cases: PropTypes.array,
  pathname: PropTypes.string,
};
